module.exports = __webpack_public_path__ + "img/overheads-web-hosting.51deb2d2.svg";